import { render } from "./RegisteredAgent.vue?vue&type=template&id=3d745c8a&scoped=true"
import script from "./RegisteredAgent.vue?vue&type=script&lang=js"
export * from "./RegisteredAgent.vue?vue&type=script&lang=js"

import "./RegisteredAgent.vue?vue&type=style&index=0&id=3d745c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d745c8a"]])

export default __exports__